import { HTTPServiceClient } from '@/packages/http/service';
import * as endpoint from './endpoints';
import {
  Response,
  PensionSchemeRequest,
  NewReportingPeriodRequest,
  DeletePensionSchemeRequest,
  PostServiceCostRequest,
  OrgPensionSchemeRequest,
  PaginatedResult,
  DeleteServiceCostRequest,
  UpdateSubFundProportionsRequest
} from './types';
import {
  createPensionSchemeRequestPayload,
  createReportingPeriodPayload,
  createServiceCostPayload
} from './service-helper';
/**
 * --------------------------------------------------
 *	Pension scheme HTTP Serice
 * --------------------------------------------------
 **/
export const PensionSchemeService = {
  async getOrganizationPensionSchemes(
    orgPensionSchemeRequest: OrgPensionSchemeRequest
  ): Promise<PaginatedResult> {
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ORGANIZATION_PENSION_SCHEMES(orgPensionSchemeRequest)
    );
    return data;
  },
  async getLiteOrganizationPensionSchemes(
    orgPensionSchemeRequest: OrgPensionSchemeRequest
  ): Promise<PaginatedResult> {
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ORGANIZATION_PENSION_SCHEMES(orgPensionSchemeRequest, true)
    );
    return data;
  },

  async postPensionScheme(
    pensionSchemeRequest: PensionSchemeRequest
  ): Promise<Response> {
    const body = createPensionSchemeRequestPayload(pensionSchemeRequest);
    const { data } = await HTTPServiceClient.post(
      endpoint.POST_PENSION_SCHEME(pensionSchemeRequest.orgId),
      body
    );
    return data;
  },

  async postNewReportingPeriod(
    newReportingPeriod: NewReportingPeriodRequest
  ): Promise<Response> {
    const body = createReportingPeriodPayload(newReportingPeriod);
    const { data } = await HTTPServiceClient.post(
      endpoint.POST_NEW_REPORTING_PERIOD(
        newReportingPeriod.orgId,
        newReportingPeriod.pensionSchemeId
      ),
      body
    );
    return data;
  },

  async putPensionScheme(
    pensionSchemeRequest: PensionSchemeRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.put(
      endpoint.PUT_PENSION_SCHEME(
        pensionSchemeRequest.orgId,
        pensionSchemeRequest.pensionSchemeId
      ),
      pensionSchemeRequest
    );
    return data;
  },

  async deletePensionScheme(
    deletePensionSchemeRequest: DeletePensionSchemeRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.delete(
      endpoint.DELETE_PENSION_SCHEME(
        deletePensionSchemeRequest.orgId,
        deletePensionSchemeRequest.pensionSchemeId,
        deletePensionSchemeRequest.investmentId
      )
    );
    return data;
  },

  async postServiceCost(
    postServiceCostRequest: PostServiceCostRequest
  ): Promise<Response> {
    const body = createServiceCostPayload(postServiceCostRequest);
    const { data } = await HTTPServiceClient.post(
      endpoint.POST_SERVICE_COST(
        postServiceCostRequest.orgId,
        postServiceCostRequest.pensionSchemeId
      ),
      body
    );
    return data;
  },

  async deleteServiceCost(
    deleteServiceCostRequest: DeleteServiceCostRequest
  ): Promise<Response> {
    const { data } = await HTTPServiceClient.delete(
      endpoint.DELETE_SERVICE_COST(
        deleteServiceCostRequest.orgId,
        deleteServiceCostRequest.pensionSchemeId,
        deleteServiceCostRequest.investmentId
      )
    );
    return data;
  },

  async updateSubFundProportions(
    updateSubFundProportionsRequest: UpdateSubFundProportionsRequest
  ): Promise<Response> {
    const postData = {
      proportions: JSON.stringify(updateSubFundProportionsRequest.proportions)
    };
    const { data } = await HTTPServiceClient.post(
      endpoint.PROPORTIONS_ENDPOINT(updateSubFundProportionsRequest.orgId),
      postData
    );
    return data;
  }
};
